/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { PARSED_FIELD_FRAGMENT } from './ParsedFieldFragment'

export const PARSED_CREATE_USER_DATA_FRAGMENT = gql`
  fragment ParsedCreateUserData on ParsedCreateUserData {
    name {
      ...ParsedField
    }
    role {
      ...ParsedField
    }
    assignedStoreName {
      ...ParsedField
    }
    pin {
      ...ParsedField
    }
    email {
      ...ParsedField
    }
  }
  ${PARSED_FIELD_FRAGMENT}
`
